import { useEffect, useCallback } from 'react'
import { OnCollaborateChangeEvent, RunningContext } from '../types/sdk'
import { useAppDispatch } from './useRTK'
import { setCollaborationId, clearCollaborationId } from '../app/root'

export const useOnCollaborateChange = (
  runningContext: RunningContext | undefined
) => {
  const dispatch = useAppDispatch()
  // set it when it changes
  const fn = useCallback(
    ({ action, collaborateUUID }: OnCollaborateChangeEvent) => {
      if (action === 'start' && collaborateUUID) {
        dispatch(setCollaborationId(collaborateUUID))
        // TODO: clear collab file as well?
      } else if (action === 'end') {
        // clear the id
        dispatch(clearCollaborationId())
      }
    },
    [dispatch]
  )

  useEffect(() => {
    // prevent zoomSdk warning
    if (runningContext && runningContext !== 'inMainClient') {
      try {
        zoomSdk.addEventListener('onCollaborateChange', fn)
      } catch {
        // do nothing to suppress warning
      }
    }

    return () => {
      if (runningContext && runningContext !== 'inMainClient') {
        try {
          zoomSdk.removeEventListener('onCollaborateChange', fn)
        } catch {
          // do nothing to suppress warning
        }
      }
    }
  }, [fn, runningContext])
}
